/* globals Class, $H */
window.jui.Menu = Class.create(window.jui.Component, {
  options: function($super,options){
    return $super($H({
      items: [],
      attributes: {
        className: 'menu popup-menu'
      }
    }).merge(options));
  },

  initialize: function($super, options) {
    this.items = [];
    this.selectedItem = null;
    $super(options);
    if (this.options.action) {
      this.addListener('actionPerformed', this.options.action);
    }
    this.activeItem = null;
  },

  installUI: function($super) {
    $super();
    this.options.items.each(function(mi) {
      switch (mi.type) {
        case 'item':
          this.addItem(new window.jui.MenuItem(mi));
          break;
        case 'divider':
          this.addItem(new window.jui.MenuDivider(mi));
          break;
      }

    }, this);
  },

  addItem: function(item) {
    item.addListener('mouseup', this.itemSelected.bind(this));
    this.items.push(this.insert(item));
  },

  removeItem: function(item) {
    this.items = this.items.without(item);
  },

  activate: function() {
    // this.selectedItem = null;
    this.fireEvent('menuActivated', this);
  },

  deactivate: function() {
    this.fireEvent('menuDeactivated', this);
  },

  itemSelected: function(e) {

    if (e.data.isEnabled()) {
      var oldSelectedItem = this.selectedItem;
      this.selectedItem = e.data;

      if (this.options.actAsToggle) {
        this.selectedItem.toggle();
      }

      if (this.options.actAsRadio && oldSelectedItem !== this.selectedItem) {
        if (oldSelectedItem !== null) {
          oldSelectedItem.toggleOff();
        }
        this.selectedItem.toggleOn();
      }

      this.fireEvent('actionPerformed', this);
    }
    window.jui.Menu.deactivateAll();
  }
});

(function() {
  var activeMenus = [];
  var _screen = null;
  var screenMouseup = false;
  var screen = function() {
    return _screen || (function() {
      _screen = new Element('div', {className: 'menu-screen popup-menu-screen'});
      _screen.observe('mousedown', window.jui.Menu.deactivateAll);
      _screen.observe('mouseup', function(e) {
          if (screenMouseup) {
              window.jui.Menu.deactivateAll(e);
          }
      });
      return _screen;
    })();
  };

  var showScreen = function(){
    if (screen().parentNode !== document.body) {
      document.body.appendChild(screen());
    }
  };

  var hideScreen = function(){
    screen().remove();
  };

  Object.extend(window.jui.Menu, {
    activate: function(menu, options) {
      /* jshint unused:vars */
      screenMouseup = false;
      (function() {
        screenMouseup = true;
      }).delay(0.7);

      showScreen();
      activeMenus.push(menu);
      document.body.insert(menu.e);
      menu.activate();
    },

    deactivateAll: function() {
      activeMenus.each(function(m) {m.deactivate(); m.e.remove();});
      activeMenus = [];
      hideScreen();
    }
  });
})();

//------------------------------------------------------------------------------
window.jui.MenuItem = Class.create(window.jui.Component, window.jui.ControlModel, window.jui.ToggleModel, {
  options: function($super,options){
    return $super($H({
      menuItems: [],
      attributes: {
        className: 'menu-item popup-menu-item'
      }
    }).merge(options));
  },

  initialize: function($super, options) {
    this.labelText = options.label || null;
    this.tag = options.tag || null;
    this.data = options.data || null;
    $super(options);
    if (this.options.action) {
      this.addListener('actionPerformed', this.options.action);
    }
  },

  installUI: function($super) {
    $super();
    var self = this;
    this.e.observe('mouseup', function() {
      self.e.removeClassName('hover');
      self.fireEvent('mouseup', self);
      if (self.isEnabled()) {
        self.fireEvent('actionPerformed', self);
      }
    });
    this.e.observe('mouseover', function(e) {
      e.stop();
      self.e.addClassName('hover');
    });
    this.e.observe('mouseout', function(e) {
      e.stop();
      self.e.removeClassName('hover');
    });

    if(!!this.options.warning) {
      this.insert(new Element('div', {className:'warning'}));
    }
    
    this.label = this.e.select('span')[0] || ((this.options.label) ? this.createLabel(this.options.label) : null);
  },

  createLabel: function(label) {
    return this.insert(new Element('span', {
      className: 'label'
    }).update(label));
  }
});

//------------------------------------------------------------------------------
window.jui.MenuDivider = Class.create(window.jui.Component, {
  options: function($super,options){
    return $super($H({
      menuItems: [],
      attributes: {
        className: 'menu-divider popup-menu-divider'
      }
    }).merge(options));
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/menu.js
// module id = 267
// module chunks = 0 1